var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-950 -530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M12,2A10,10,0,1,0,22,12,10.029,10.029,0,0,0,12,2Zm3.7,12.3a.99.99,0,0,1-1.4,1.4L12,13.4,9.7,15.7a.99.99,0,0,1-1.4-1.4L10.6,12,8.3,9.7A.99.99,0,0,1,9.7,8.3L12,10.6l2.3-2.3a.99.99,0,1,1,1.4,1.4L13.4,12Z",
    transform: "translate(948 528)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 6,
    y2: 6,
    transform: "translate(957 537)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 6,
    y2: 6,
    transform: "translate(963 537) rotate(90)",
    fill: "none",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageClose);
export default __webpack_public_path__ + "static/media/image-close.c6b87b65330dfc0a351d08a01be287e9.svg";
export { ForwardRef as ReactComponent };